import { 
    OnDemandContent, 
    ProgramGuide, 
    OnDemandData, 
    ItemPaging,
    CreditsPage,
    ChannelsContent,
    FavoriteChannels
} from '@ca.vmedia.tv/domains';


export interface ExposeInterface {
    emptyOnDemandContent: () => OnDemandContent;
    emptyChannelsContent: () => ChannelsContent;
    emptyCreditsPage: () => CreditsPage;
    emptyOnDemandData: () => OnDemandData;
    emptyProgramGuide: () => ProgramGuide;
    emptyFavoriteChannels: () => FavoriteChannels;
}

export const useEmptyLine = () => {
    const emptyOnDemandContent = (): OnDemandContent => new OnDemandContent([], null, null, null, new ItemPaging(0, 0, 0, 0));
    const emptyChannelsContent = (): ChannelsContent => new ChannelsContent([], null, null, new ItemPaging(0, 0, 0, 0));
    const emptyCreditsPage = (): CreditsPage => new CreditsPage([], new ItemPaging(0, 0, 0, 0));
    const emptyOnDemandData = (): OnDemandData => new OnDemandData([], null, new ItemPaging(0, 0, 0, 0));
    const emptyProgramGuide = (): ProgramGuide => new ProgramGuide([], null, new ItemPaging(0, 0, 0, 0));
    const emptyFavoriteChannels = (): FavoriteChannels => new FavoriteChannels([], new ItemPaging(0, 0, 0, 0));

    return <ExposeInterface> {
        emptyOnDemandContent,
        emptyChannelsContent,
        emptyCreditsPage,
        emptyOnDemandData,
        emptyProgramGuide,
        emptyFavoriteChannels
    }
};
